export default __webpack_public_path__ + "static/media/load.8fa1f8bc.svg";